import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import User from '../../../components/user/user';


function HomeUserScreen () {
    return (
        <Fragment>
            <Head titulo="Área de Usuário | Departamento de TI" />
            <Header />
            <User />
            <Footer />
        </Fragment>
    );
}

export default HomeUserScreen;